import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Utensils, Coffee, Sunrise, Moon, Map } from 'lucide-react';
const deliverables = [{
  title: 'The Full Menopause Belly Reset Digital Manual',
  icon: BookOpen,
  format: '(PDF)'
}, {
  title: 'The "3-Day Emergency Debloat" Step-by-Step Menu',
  icon: Utensils
}, {
  title: 'The Adrenal Cocktail Recipe',
  icon: Coffee,
  desc: '(To stop the 3 PM sugar cravings)'
}, {
  title: 'The "Protein-First" Morning Routine',
  icon: Sunrise,
  desc: 'To lock in fat burning by 8 AM'
}, {
  title: 'The 4-7-8 Deep Sleep Protocol',
  icon: Moon,
  desc: 'To eliminate 3 AM wake-ups'
}, {
  title: 'The "Dining Out with Hormones" Cheat Sheet',
  icon: Map
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export const WhatYouGet = () => {
  return <section className="py-24 bg-wellness-sage text-wellness-forest" data-id="element-129">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-4xl md:text-5xl mb-6 text-white" data-id="element-132">What You Get</h2>
          <p className="text-xl font-serif text-white/90 italic" data-id="element-133">
            Everything you need to reset your body, delivered instantly.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-134">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-wellness-cream/95 backdrop-blur-sm p-8 rounded-2xl flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-135">
              <div className="w-14 h-14 rounded-full bg-wellness-sage/20 flex items-center justify-center mb-5 text-wellness-forest" data-id="element-136">
                <item.icon strokeWidth={1.5} size={28} data-id="element-137" />
              </div>
              <h3 className="text-xl mb-2 leading-snug" data-id="element-138">
                {item.title}{' '}
                {item.format && <span className="text-sm font-sans font-normal text-wellness-forest/60" data-id="element-139">
                    {item.format}
                  </span>}
              </h3>
              {item.desc && <p className="font-sans text-sm text-wellness-forest/70 mt-auto pt-2" data-id="element-140">
                  {item.desc}
                </p>}
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};